// fareEngine.js — מנוע תמחור למשלוחים: מחיר לפי מרחק + גודל חבילה.

export const DELIVERY_TARIFF = {
  baseFare: 15,
  perKm: 3,
  minimumFare: 20,
  sizeMultiplier: { small: 1, medium: 1.3, large: 1.7 },
};

export const COMMISSION_RATE = 0.15;

export function calculateDeliveryFare(distanceKm, sizeCategory = "small", opts = {}) {
  const t = { ...DELIVERY_TARIFF, ...(opts.tariff || {}) };
  const mult = t.sizeMultiplier[sizeCategory] || 1;
  let fare = (t.baseFare + distanceKm * t.perKm) * mult;
  fare = Math.max(fare, t.minimumFare);
  return Math.round(fare);
}

export function splitFare(fare, rate = COMMISSION_RATE) {
  const platformCommission = Math.round(fare * rate);
  return { platformCommission, courierPayout: fare - platformCommission };
}

export function getRouteEstimate(origin, destination) {
  return new Promise((resolve, reject) => {
    if (!window.google || !window.google.maps) {
      return reject(new Error("Google Maps לא נטען עדיין"));
    }
    const service = new window.google.maps.DirectionsService();
    service.route(
      {
        origin: { lat: origin.lat, lng: origin.lng },
        destination: { lat: destination.lat, lng: destination.lng },
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status !== "OK" || !result.routes[0]) {
          return reject(new Error("חישוב מסלול נכשל: " + status));
        }
        const leg = result.routes[0].legs[0];
        resolve({
          distanceKm: +(leg.distance.value / 1000).toFixed(1),
          durationMin: Math.round(leg.duration.value / 60),
          rawResult: result,
        });
      }
    );
  });
}
